<template>
  <v-container>
    <p class="text-left text-h5 font-weight-bold"><span style="color: #ff0000;"><strong><span
      style="font-size: 18pt;">■&nbsp;注意須知</span></strong></span></p>
    <p class="mt-6" style="color:red;">一、手機載具綁定後,繳費完即可自動將發票存入財政部手機條碼。如因輸入資料錯誤所致損害,本公司恕不負責。</p>
    <p>二、確認査詢手機號碼是否為租賃場地登記聯絡手機號碼，車號依目前綁定的車號查詢。</p>
    <p>三、手機載具輸入時請確認是否輸入正確，避免發票無法歸戶至您的手機載具，請注意數字0(比較瘦小)和英文的O(比較圓)。</p>
    <p>四、原使用手機載具，如不想使用，欲改拿紙本發票時，請清除手機載具註冊。</p>
    <p>五、請在繳費之前設定好手機載具，交易時會依系統目前登記的手機載具開立發票。</p>
    <p>六、更換手機載具時，請在超商繳費前更換完畢，避免發票開立歸戶還是舊的手機載具。</p>
    <p>七、如發生手機載具設定錯誤需重新開立發票，請洽租賃場地管理人員辦理發票作廢重開作業。</p>
    <v-divider class="mt-2 mb-2"></v-divider>
    <v-row v-if="showBody" class="mt-10 mb-4" justify="center">
      <v-col cols="12" md="8">如管理人員協助掃描載具編碼，請記得確認鍵送出，否則載具編碼不會生效。</v-col>
      <v-col cols="12" md="8">
        <v-data-table :headers="headers" :items="list" class="elevation-1">
          <template v-slot:[`item.RentInfo_VarParamA`]="{ item }">
            {{ item.RentInfo_VarParamA }}
          </template>
          <template v-slot:[`item.RentInfo_RentName`]="{ item }">
            {{ item.RentInfo_RentName }}
          </template>
          <template v-slot:[`item.RentInfo_Carrier`]="{ item }">
            <span v-show="!item.RentInfo_TempCarrier">{{
              item.RentInfo_Carrier ? item.RentInfo_Carrier : "尚未註冊手機載具"
            }}</span>
            <span v-show="item.RentInfo_TempCarrier">{{
              item.RentInfo_TempCarrier
                ? item.RentInfo_TempCarrier
                : "尚未註冊手機載具"
            }}</span>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-btn v-if="!item.RentInfo_TempCarrier" dark small rounded color="primary" @click="modifyCarrier(item)"
              :disabled="detailShow">修改</v-btn>
            <v-btn v-if="item.RentInfo_TempCarrier" dark small rounded color="green"
              @click="modifyTempCarrier(item, 1)">確認</v-btn>
            <v-btn v-if="item.RentInfo_TempCarrier" class="ma-2" dark small rounded color="red"
              @click="modifyTempCarrier(item, 2)">移除</v-btn>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-stepper v-model="step" v-show="detailShow">
      <v-stepper-header>
        <v-stepper-step :complete="step > 1" step="1">填寫手機載具</v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step :complete="step > 2" step="2">手機簡訊認證</v-stepper-step>

        <v-divider></v-divider>
      </v-stepper-header>
      <v-stepper-items>
        <v-stepper-content step="1">
          <v-form ref="verifyCarrier" v-model="validCarrier" @submit.prevent="submitCarrier">
            <v-row class="mt-10 mb-6" justify="center">
              <v-col cols="12" sm="6" md="4">
                <v-text-field ref="carrier" v-model="carrier" label="請輸入手機載具號碼" :rules="carrierRules" :counter="8"
                  required></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="carrierConfirm" label="再次確認手機載具號碼"
                  :rules="[(v) => v === this.carrier || '手機載具不一致']" :counter="8" required></v-text-field>
              </v-col>
            </v-row>
            <p class="text-center">或</p>
            <v-row justify="center">
              <v-col cols="4" md="3">
                <v-btn block color="error" class="mb-4" type="button" @click="delShow = true">解除綁定</v-btn>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row justify="center">
              <v-col cols="4" md="2">
                <v-btn block class="mt-3 mb-1" type="button" @click="cancelRegister">取消</v-btn>
              </v-col>
              <v-col cols="4" md="2">
                <v-btn block color="primary" class="mt-3 mb-1" type="submit">下一步</v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-stepper-content>
        <v-stepper-content step="2">
          <v-form>
            <v-row class="mt-2" justify="center">
              <v-col cols="12" class="text-center">
                <span class="text-h5">認證碼已發送至 {{ tempRent.RentInfo_Mobile }} ，待
                  {{ vaildDate | toDateFormat("YYYY-MM-DD HH:mm") }}
                  後才能重新發送</span>
              </v-col>
            </v-row>
            <v-row class="mt-10 mb-6" justify="center">
              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model.number="verifyCode" label="驗證碼" :rules="[
                  (v) => !!v || '必填項目',
                  (v) => (v >= 100000 && v <= 999999) || '請填入 6 個數字',
                ]" required></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" offset-md="3" md="3">
                <v-btn block color="primary" class="mt-3" type="button" @click="editCarrier">送出</v-btn>
              </v-col>
              <v-col cols="6" md="3">
                <v-btn block color="error" class="mt-3" type="button" @click="cancelRegister">取消</v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>

    <v-dialog v-model="delShow" scrollable max-width="400px">
      <v-card>
        <v-card-title>溫馨提醒</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="text-center">
          <p class="text-h4 mt-4">確定解除綁定載具？</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" type="button" @click="delShow = false">放棄解除</v-btn>
          <v-btn color="error" type="button" @click="submitCarrier">確定解除</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog" transition="dialog-bottom-transition" max-width="500px" persistent>
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>注意需知</v-toolbar-title>
          <v-spacer />
          <v-btn icon dark @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <p class="mt-6" style="color:red;">一、手機載具綁定後,繳費完即可自動將發票存入財政部手機條碼。如因輸入資料錯誤所致損害,本公司恕不負責。</p>
          <p>二、確認査詢手機號碼是否為租賃場地登記聯絡手機號碼，車號依目前綁定的車號查詢。</p>
          <p>三、手機載具輸入時請確認是否輸入正確，避免發票無法歸戶至您的手機載具，請注意數字0(比較瘦小)和英文的O(比較圓)。</p>
          <p>四、原使用手機載具，如不想使用，欲改拿紙本發票時，請清除手機載具註冊。</p>
          <p>五、請在繳費之前設定好手機載具，交易時會依系統目前登記的手機載具開立發票。</p>
          <p>六、更換手機載具時，請在超商繳費前更換完畢，避免發票開立歸戶還是舊的手機載具。</p>
          <p>七、如發生手機載具設定錯誤需重新開立發票，請洽租賃場地管理人員辦理發票作廢重開作業。</p>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="tempCarrierShow" scrollable max-width="450px">
      <v-card>
        <v-card-title>溫馨提醒</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="text-center">
          <p v-show="tempCarrierSet === 1" class="text-h5 mt-4">
            確認註冊以下載具編碼?
          </p>
          <p v-show="tempCarrierSet === 2" class="text-h5 mt-4">
            確定移除該載具編碼？
          </p>
          <p class="text-h5 mt-4">{{ tempRent.RentInfo_TempCarrier }}</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" type="button" @click="tempCarrierShow = false">取消</v-btn>
          <v-btn v-show="tempCarrierSet === 1" dark color="green" type="button" @click="handleTempCarrier">確定</v-btn>
          <v-btn v-show="tempCarrierSet === 2" color="error" type="button" @click="handleTempCarrier">移除</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import moment from 'moment';

export default {
  name: 'ChangeProfile',
  data: () => ({
    validCarrier: false,
    carrier: null,
    carrierConfirm: null,
    carrierRules: [
      (v) => !!v || '必填項目',
      (v) => /^\/[\dA-Z0-9+-.]{7}$/.test(v) || '請輸入正確手機載具格式'
    ],
    verifyCode: '',
    vaildDate: null,
    showBody: false,
    tempRent: {},
    headers: [
      { text: '場地', value: 'RentInfo_VarParamA' },
      { text: '租戶', value: 'RentInfo_RentName' },
      { text: '載具編碼', value: 'RentInfo_Carrier' },
      { text: '操作', value: 'actions' }
    ],
    list: [
      {
        RentInfo_Code: 1,
        RentInfo_RentName: '2',
        RentInfo_Carrier: '/qq',
        RentInfo_VarParamA: '場A'
      }
    ],
    dialog: false,
    detailShow: false,
    delShow: false,
    step: 1,
    tempCarrierShow: false,
    tempCarrierSet: 0
  }),
  watch: {
    detailShow: function (value) {
      if (!value) {
        this.step = 1;
      }
    }
  },
  mounted() {
    // 強制打開
    // this.dialog = true;
  },
  created() {
    this.search();
  },
  methods: {
    search() {
      this.dbio('/ChangeProfile', {}).then((response) => {
          this.list = response;

          if (this.list.length === 0) {
            this.msg('查無此手機用戶', 2000);
          } else {
            this.showBody = true;
          }
        });
    },
    submitCarrier() {
      if (this.validCarrier || this.delShow) {
        this.dbio(
          '/ChangeProfile/SendSMS',
          {
            RentInfo_Code: this.tempRent.RentInfo_Code
          },
          'post'
        ).then((response) => {
          if (response) {
            if (this.delShow) {
              this.delShow = false;
              this.$refs.verifyCarrier.reset();
            }
            this.vaildDate = moment.utc(response);
            this.step += 1;
          } else {
            this.msg('簡訊未發送成功');
          }
        });
      }
    },
    modifyCarrier(item) {
      this.tempRent = item;
      this.detailShow = true;
      const _this = this;
      setTimeout(function () {
        _this.$refs.carrier.focus();
      }, 200);
    },
    cancelRegister() {
      this.$refs.verifyCarrier.reset();
      this.verifyCode = null;
      this.detailShow = false;
    },
    editCarrier() {
      if (
        this.verifyCode &&
        this.verifyCode >= 100000 &&
        this.verifyCode <= 999999
      ) {
        this.dbio(
          '/ChangeProfile',
          {
            MobileCarrier: this.carrier,
            VerifyCode: this.verifyCode,
            RentInfo_Code: this.tempRent.RentInfo_Code
          },
          'post'
        ).then(() => {
          this.cancelRegister();
          this.search();
        });
      }
    },
    modifyTempCarrier(item, type) {
      this.tempRent = item;
      this.tempCarrierShow = true;
      this.tempCarrierSet = type;
    },
    handleTempCarrier() {
      this.dbio(
        '/ChangeProfile/ModifyCarrier',
        {
          MobileCarrierSet: this.tempCarrierSet,
          RentInfo_Code: this.tempRent.RentInfo_Code
        },
        'post'
      ).then(() => {
        this.tempCarrierShow = false;
        this.tempCarrierSet = 0;
        this.search();
      });
    }
  }
};
</script>